const CONTENT_MAP_SESSION_KEY = "gesb-content-map-enabled"

/**
 * Whether the Content Map debug UI (?contentMap) is enabled.
 * Checks the document query and the hash query (HashRouter keeps query in the hash).
 */
export function isContentMapDebugActive(): boolean {
  if (typeof window === "undefined") return false
  if (new URLSearchParams(window.location.search).has("contentMap")) {
    return true
  }
  const hash = window.location.hash
  const q = hash.indexOf("?")
  if (q >= 0 && new URLSearchParams(hash.slice(q)).has("contentMap")) {
    return true
  }
  return false
}

export function isContentMapSessionEnabled(): boolean {
  if (typeof window === "undefined") return false
  try {
    return sessionStorage.getItem(CONTENT_MAP_SESSION_KEY) === "1"
  } catch {
    return false
  }
}

export function setContentMapSessionEnabled(enabled: boolean): void {
  if (typeof window === "undefined") return
  try {
    if (enabled) {
      sessionStorage.setItem(CONTENT_MAP_SESSION_KEY, "1")
    } else {
      sessionStorage.removeItem(CONTENT_MAP_SESSION_KEY)
    }
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

/** Query flag, hash flag, or session toggle from the content map icon. */
export function isContentMapActive(): boolean {
  return isContentMapDebugActive() || isContentMapSessionEnabled()
}

export function readContentMapInitialEnabled(search: string): boolean {
  return (
    isContentMapDebugActive() ||
    new URLSearchParams(search).has("contentMap") ||
    isContentMapSessionEnabled()
  )
}
